import { defineAbility } from '@casl/ability';
import { Role, PortalClienteResource } from './role';

export default function defineAbilitiesFor(currentProfile) {

  var roles = currentProfile.roles;
  return defineAbility((can) => {
    if (roles != undefined) {
      for (var i = 0; i < roles.length; i++) {
        const role = roles[i]
        const meta = Role[role]
        if (meta != undefined) {
          if (meta.resource != undefined) {

            if (meta.checkNoAgentIsAssigned != undefined) {
              // chequear o bien que no haya asignado un agente para ciertos permisos o que el uuid del agente de la reclamacion coincida con el que tiene asignado la reclamacion
              can(meta.action, meta.resource, { uuid: meta.checkNoAgentIsAssigned == true ? null : currentProfile.uuid });

            } else if (meta.checkAnyAgentIsAssigned != undefined) {
              // se necesita la presencia de un agente tramitador asignado a la reclamacion
              can(meta.action, meta.resource, { hasAgent: true });

            } else if (meta.checkNotarioIsAssigned != undefined) {
              const paramsToCheck = { uuid: meta.checkNotarioIsAssigned == false ? null : currentProfile.uuid }
              if (meta.status != undefined) paramsToCheck["status"] = meta.status
              can(meta.action, meta.resource, paramsToCheck);
            }

          } else {
            can(meta.action, PortalClienteResource);
          }

        }

      }
    }
  })

}